<template>
  <v-card
    elevation="0"
    class="pa-4 rounded-xxl d-flex align-center justify-space-between"
    :color="color.primaryVariantClear"
  >
    <div class="d-flex align-center">
    <v-avatar size="100">
      <img :src="icon" alt="benefic_image" />
    </v-avatar>
    <div class="overflow-y-auto mx-4">
      <h3>{{ name }}</h3>
      <p style="font-size: 11px">
        {{ description }}
      </p>
    </div>
    </div>
    <div id="actions" class="d-flex">
      <v-btn
        v-if="validateOrganization"
        x-small
        @click="handleEdit()"
        elevation="0"
        class="white--text text-capitalize rounded-pill"
        fab
        :color="color.primaryVariant"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        v-if="validateOrganization"
        x-small
        elevation="0"
        @click="handleDelete()"
        class="white--text text-capitalize rounded-pill ml-4"
        fab
        color="red"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </div>
  </v-card>
</template>
<script>
import { colors } from '@/constants/colors.js';
import { mapState } from 'vuex/dist/vuex.common.js';

export default {
  props: {
    name: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
    },
    description: {
      type: String,
      default: '',
    },
    expiredDate: {
      type: Date,
    },
  },
  data() {
    return {
      color: colors,
    };
  },
  methods: {
    handleEdit() {
      this.$emit('edit');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
  computed: {
    ...mapState('user', ['user']),
    validateOrganization() {
      return ['HEAD_OFFICE', 'BRANCH', 'ORGANIZATION'].includes(this.user.role);
    },
  },
};
</script>
